<button mat-icon-button class="matero-toolbar-button" [matMenuTriggerFor]="menuLanguage">
  <mat-icon>language</mat-icon>
</button>

<mat-menu #menuLanguage="matMenu" class="mat-app-background">
  <button mat-menu-item *ngFor="let lang of langs | keyvalue" (click)="useLanguage(lang.key)">
    <span>{{ lang.value }}</span>
  </button>
</mat-menu>
